// Fixed film-grain overlay for cinematic texture.
export function Grain() {
  return <div className="grain" aria-hidden="true" />;
}
